// characters: список персонажей. ЗЕРКАЛО server/internal/progress.Characters —
// id/порядок/«родной» стат должны совпадать (id уходит в протокол и в БД).

export type StatKey = "hp" | "speed" | "armor";

export const STAT_KEYS: readonly StatKey[] = ["hp", "speed", "armor"];

export const STAT_LABELS: Record<StatKey, string> = {
  hp: "Здоровье",
  speed: "Скорость",
  armor: "Броня",
};

export interface CharacterDef {
  id: number;
  key: string;
  name: string;
  /** Кто это (подзаголовок карусели). */
  title: string;
  /** Одна-две фразы о персонаже и его сильной стороне. */
  blurb: string;
  /** «Родной» стат: +1 уровень бесплатно (сервер: progress.NewLoadout). */
  bonus: StatKey;
  /** Основной GLB (скин + все клипы солдата). */
  model: string;
  /** Внутренний «мясной» меш для воксельного урона (тот же скелет). */
  inner: string;
  /** Рост в игре, м (bbox idle-позы). У солдата исторически 1.8. */
  desiredHeight: number;
  /** Спрайт-лист поворота на 360° для превью в меню (кадры по горизонтали). */
  turntable: string;
  turntableFrames: number;
}

export const CHARACTERS: readonly CharacterDef[] = [
  {
    id: 0,
    key: "soldier",
    name: "Солдат",
    title: "Штурмовик спецотряда",
    blurb: "Каска и бронежилет. Держит удар лучше остальных.",
    bonus: "armor",
    model: "/models/soldier.glb",
    inner: "/models/soldier_animated_vox.glb",
    desiredHeight: 1.8,
    turntable: "/characters/soldier_turn.png",
    turntableFrames: 16,
  },
  {
    id: 1,
    key: "investigator",
    name: "Сыщица",
    title: "Исследовательница оккультного",
    blurb: "Лёгкая кожанка и сапоги на шнуровке — первой добегает до укрытия.",
    bonus: "speed",
    model: "/models/characters/investigator.glb",
    inner: "/models/characters/investigator_vox.glb",
    desiredHeight: 1.72,
    turntable: "/characters/investigator_turn.png",
    turntableFrames: 16,
  },
  {
    id: 2,
    key: "hunter",
    name: "Охотник",
    title: "Охотник на нечисть",
    blurb: "Маска-череп, серебряные колья на перевязи. Живучий: выдерживает лишнее попадание.",
    bonus: "hp",
    model: "/models/characters/hunter.glb",
    inner: "/models/characters/hunter_vox.glb",
    desiredHeight: 1.84,
    turntable: "/characters/hunter_turn.png",
    turntableFrames: 16,
  },
];

export function isValidCharacterId(id: number): boolean {
  return Number.isInteger(id) && id >= 0 && id < CHARACTERS.length;
}

export function characterById(id: number): CharacterDef {
  return isValidCharacterId(id) ? CHARACTERS[id]! : CHARACTERS[0]!;
}
